import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCalculator, FaUniversity, FaUsers, FaBriefcase, FaChartLine, FaProjectDiagram, FaFileSignature, FaUserTie, FaExchangeAlt, FaBookReader, FaChevronUp } from 'react-icons/fa';
import './ActuarialScience.css';

const ActuarialScience = () => {
    const [activeTab, setActiveTab] = useState('about');

    const facultyData = [
        { name: "Kasırga Yıldırak", title: "Prof. Dr.", avesis_url: "https://avesis.hacettepe.edu.tr/kasirga", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7877" },
        { name: "Uğur Karabey", title: "Doç. Dr.", is_president: true, avesis_url: "https://avesis.hacettepe.edu.tr/ukarabey", photo_url: "https://avesis.hacettepe.edu.tr/user/image/5811" },
        { name: "Murat Büyükyazıcı", title: "Dr. Öğr. Üyesi", avesis_url: "https://avesis.hacettepe.edu.tr/muratby", photo_url: "https://avesis.hacettepe.edu.tr/user/image/6678" },
        { name: "Yasemin Gençtürk", title: "Dr. Öğr. Üyesi", avesis_url: "https://aktuerya.hacettepe.edu.tr/pers/YaseminGencturk.php", photo_url: "https://aktuerya.hacettepe.edu.tr/pers/resimler/yg.jpg" },
        { name: "Başak Bulut Karageyik", title: "Dr. Öğr. Üyesi", avesis_url: "https://avesis.hacettepe.edu.tr/basakbulut", photo_url: "https://avesis.hacettepe.edu.tr/user/image/8452" },
        { name: "Aslıhan Şentürk Acar", title: "Dr. Öğr. Üyesi", avesis_url: "https://avesis.hacettepe.edu.tr/aslihans", photo_url: "https://avesis.hacettepe.edu.tr/user/image/7744" },
        { name: "Övgücan Karadağ Erdemir", title: "Dr. Öğr. Üyesi", avesis_url: "https://avesis.hacettepe.edu.tr/ovgucan", photo_url: "https://avesis.hacettepe.edu.tr/user/image/8242" },
        { name: "Öznur Özaltın", title: "Dr. Öğr. Üyesi", avesis_url: "https://avesis.hacettepe.edu.tr/oznurozaltin", photo_url: "https://avesis.hacettepe.edu.tr/user/image/13681" },
    ];

    const admissionScores = [
        { year: 2018, low: 243.336, high: 318.115 },
        { year: 2019, low: 256.175, high: 383.714 },
        { year: 2020, low: 278.192, high: 412.315 },
        { year: 2021, low: 240.338, high: 314.701 },
        { year: 2022, low: 296.629, high: 416.253 },
        { year: 2023, low: 328.775, high: 377.852 },
        { year: 2024, low: 324.511, high: 385.832 },
    ];
    
    return (
        <div className="actuarial-page">
            <header className="actuarial-hero">
                <div className="actuarial-hero-content">
                    <h1>Aktüerya Bilimleri Bölümü</h1>
                    <p>Finansal Risklerin Modellenmesi ve Yönetimi</p>
                </div>
            </header>

            <div className="actuarial-nav">
                <button onClick={() => setActiveTab('about')} className={activeTab === 'about' ? 'active' : ''}>Bölüm Hakkında</button>
                <button onClick={() => setActiveTab('faculty')} className={activeTab === 'faculty' ? 'active' : ''}>Akademik Kadro</button>
                <button onClick={() => setActiveTab('actuary')} className={activeTab === 'actuary' ? 'active' : ''}>Aktüerlik</button>
                <button onClick={() => setActiveTab('projects')} className={activeTab === 'projects' ? 'active' : ''}>Projeler</button>
                <button onClick={() => setActiveTab('exchange')} className={activeTab === 'exchange' ? 'active' : ''}>Değişim Programları</button>
                <button onClick={() => setActiveTab('programs')} className={activeTab === 'programs' ? 'active' : ''}>Yan Dal & ÇAP</button>
            </div>
            
            <main className="actuarial-main-content">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={activeTab}
                        initial={{ y: 20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -20, opacity: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        {activeTab === 'about' && <AboutSection scores={admissionScores} />}
                        {activeTab === 'faculty' && <FacultySection members={facultyData} />}
                        {activeTab === 'actuary' && <ActuarySection />}
                        {activeTab === 'projects' && <ProjectsSection />}
                        {activeTab === 'exchange' && <ExchangeSection />}
                        {activeTab === 'programs' && <MinorMajorSection />}
                    </motion.div>
                </AnimatePresence>
            </main>
        </div>
    );
};

const AboutSection = ({ scores }) => (
    <div className="actuarial-section">
        <h3>Program Hakkında Genel Bilgi</h3>
        <p className="actuarial-intro">Aktüerya Bilimleri Bölümünde öğretim, bir yıl seçmeli yabancı dil hazırlık sınıfı ve dört yıl yabancı dil (İngilizce) destekli Türkçe lisans programı olarak yürütülmektedir.</p>
        <p>Bölümümüzde bir profesör, bir doçent, dört doktor öğretim üyesi, beş doktoralı araştırma görevlisi, doktora eğitimlerine devam eden beş araştırma görevlisi ve bir öğretim görevlisi bulunmaktadır. Ayrıca bölümümüzde T.C. Hazine Müsteşarlığı Sigorta Denetleme Kurulu ve Sigortacılık Genel Müdürlüğü uzmanları ile çeşitli arşatırma ve danışmanlık şirketlerinden uzmanlar ek öğretim görevlisi olarak ders vermektedir.</p>
        
        <h3>Giriş Puanları (YKS-SAY)</h3>
        <p>Bölüme Yükseköğretim Kurumları Sınavı (YKS) SAY puan türüne göre öğrenci alınmakta olup geçtiğimiz yıllar için en düşük ve en yüksek giriş puanları aşağıdaki tabloda sunulmuştur.</p>
        <div className="scores-table">
            <div className="table-header">
                <div>Yıl</div>
                <div>En Düşük Puan</div>
                <div>En Yüksek Puan</div>
            </div>
            {scores.map(score => (
                <div className="table-row" key={score.year}>
                    <div>{score.year}</div>
                    <div>{score.low.toFixed(3)}</div>
                    <div>{score.high.toFixed(3)}</div>
                </div>
            ))}
        </div>

        <h3>Öğretim Programı ve Dersler</h3>
        <p>Dört yıllık lisans programının ilk iki yılında dersler matematik, istatistik ve ekonomi ağırlıklı olup Aktüerya Bilimleri alanına ilişkin temel bilgiler verilmektedir. Son iki yılda ise Finansal Matematik, Hayat ve Hayat Dışı Sigortalar Matematiği, Aktüerya Matematiği, Emeklilik Matematiği, Aktüeryal Yazılımlar, Risk Kuramı, Hasar Modelleri, Risk Yönetimi, Stokastik Süreçler, Regresyon ve Zaman Serileri alanlarında teknik bilgiler içeren uzmanlık dersleri verilmektedir. Programda bu derslerin yanında ekonomi, işletme, hukuk, bilgisayar ve finans ile ilgili dersler de yer almaktadır. Bölüm öğrencilerinin lisans programından mezun olabilmek için 17'si ortak zorunlu olmak üzere 151 AKTS zorunlu ve 89 AKTS seçmeli ders alarak 240 AKTS'yi tamamlamaları gerekmektedir.</p>
        <p>Seçmeli derslerin İngilizce dersler dışındaki zorunlu derslere oranı yaklaşık olarak % 25'tir. Seçmeli dersler arasında "Genel İşletme" , "Hukuka Giriş", "Genel Muhasebe", "Finansal Okuryazarlık" ve "Felsefeye Giriş" gibi sosyal bilim dersleri de yer almaktadır.</p>
        <p>Lisansüstü öğretimde ise Hayat ve Hayat Dışı Sigortalar Matematiği, Aktüeryal Risk Kuramı, Hasar Modelleri, Emeklilik Matematiği, Portföy Kuramı ve Finansal Zaman Serileri gibi dersler okutulmaktadır.</p>

        <h3>Akademik Fırsatlar ve İş Birlikleri</h3>
        <p>Lisans programı süresince isteyen öğrenciler İktisat, İşletme, İstatistik, Matematik ve Endüstri Mühendisliği Bölümlerinde yan dal ve Biyoloji, İstatistik ve Matematik bölümlerinde çift anadal yapabilmektedir. Ayrıca bölümümüzün Erasmus Öğrenci Değişim programı kapsamında anlaşmalı olduğu Czestochowa University of Technology-Polonya ve University of Piraeus-Yunanistan okullarında eğitim alabilmektedirler.</p>
        <p>Hacettepe Üniversitesi Aktüerya Bilimleri Bölümü, Hazine Müsteşarlığı Sigorta Denetleme Kurulu, Sigortacılık Genel Müdürlüğü; Türkiye Sigorta ve Reasürans Şirketleri Birliği, Sigortacılık Eğitim Merkezi, Sigorta Bilgi Merkezi, Hayat Sigortası Bilgi Merkezi, Emeklilik Gözetim Merkezi, Trafik Bilgi Merkezi, Tarım Sigortaları Havuzu, Aktüerler Derneği, Sigorta Şirketleri, Sosyal Güvenlik Kurumu, Türkiye İş Kurumu, ODTÜ Uygulamalı Matematik Enstitüsü, Bahçeşehir Üniversitesi Fen Bilimleri Enstitüsü ve Marmara Üniversitesi Bankacılık ve Sigortacılık Yüksekokulu ile iş birliği yapmaktadır. Yurt dışında ise Society of Actuaries, Casualty of Actuaries, Canadian Institute of Actuaries, Heriot-Watt University, City University ile iş birliği içerisindedir.</p>
    </div>
);

const FacultySection = ({ members }) => (
    <div className="actuarial-section">
        <div className="actuarial-faculty-grid">
            {members.map(member => (
                <div className="actuarial-faculty-card" key={member.name}>
                    <img src={member.photo_url} alt={member.name} onError={(e) => { e.target.src = 'default-avatar.png'; }} />
                    <div className="faculty-card-info">
                        <h4>{member.name}</h4>
                        <p>{member.title}</p>
                        <a href={member.avesis_url} target="_blank" rel="noopener noreferrer">AVESİS Profili</a>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

const ActuarySection = () => (
    <div className="actuarial-section">
        <h3>Aktüerlik Mesleği</h3>
        <p>Hacettepe Üniversitesi Aktüerya Bilimleri Bölümünden mezun olan öğrenciler doğrudan aktüer unvanını alamamakla birlikte kamu, sigorta ve finans sektöründe aktüerya uzmanı olarak sigorta şirketlerinde çalışabilmektedirler. Mezun öğrencilerin %90'ı sigorta ve finans sektöründe çalışmaktadır. Mezunlarımız sigorta şirketleri yanı sıra brokerlik, eksperlik, denetim ve danışmanlık şirketlerinde de istihdam edilmektedir.</p>
        <p>03/08/1995 tarihli 22363 sayılı Resmi Gazete'de yayınlanan Aktüerler Yönetmeliği'ne göre Hacettepe Üniversitesi Aktüerya Bilimleri Ana Bilim Dalında Yüksek Lisans öğrenimini tamamlayarak unvan alan sicile kayıtlı olan 21 mezunumuz bulunmaktadır. 15/08/2007 tarihli ve 26614 sayılı Resmi Gazete'de yayımlanarak yürürlüğe giren yeni Aktüerler Yönetmeliği'ne göre unvan almak için üç seviyeden oluşan aktüerlik sınavlarını başarı ile tamamlamış olma ve yurt içinde veya yurt dışında; özel kurumların, kamu kurumlarının veya üniversitelerin aktüeryayla ilgili birim veya bölümlerinde veya aktüerin refakatinde aktüeryayla ilgili toplam üç yıl mesleki uygulama veya faaliyette bulunmuş olma koşullarını sağlamaları gerekmektedir. Bu yönetmeliğe göre, birinci seviye sınavlarında başarılı olanlar stajyer aktüer, ikinci seviye sınavlarında başarılı olanlar yardımcı aktüer , üçüncü seviye aktüerlik sınavlarında başarılı olanlar ve bir aktüerin yanında en az üç yıl çalışmış olan kişiler imza yetkisine sahip aktüer unvanını almaktadırlar.</p>
    </div>
);

const ProjectsSection = () => (
    <div className="actuarial-section">
        <div className="project-card">
            <img src="https://aktuerya.hacettepe.edu.tr/duyurular/tarsim.jpg" alt="TARSİM Projesi" />
            <div className="project-info">
                <h4>TARSİM Projesi</h4>
                <p>Tarımsal sigorta risklerinin değerlendirilmesi amacıyla, TARSİM'den sağlanan 8 yıllık veri kullanılarak mekansal-zamansal interpolasyon teknikleriyle aktüeryal riskler sınıflandırılmış ve önceliklendirilmiştir.</p>
            </div>
        </div>
         <div className="project-card">
            <img src="https://aktuerya.hacettepe.edu.tr/duyurular/hazinemustesarligi.jpg" alt="Hazine Müsteşarlığı Projesi" />
            <div className="project-info">
                <h4>T.C. BAŞBAKANLIK HAZİNE MÜSTEŞARLIĞI</h4>
                <p>Türkiye Sigortalı ve Anüitant Hayat Tabloları ve Projeksiyonları (2017) ve Türkiye Hayat ve Hayat Annüite Tablolarının Oluşturulması (2010) projeleri yürütülmüştür.</p>
            </div>
        </div>
    </div>
);

const ExchangeSection = () => (
    <div className="actuarial-section">
        <h3>Erasmus+ Değişim Programı</h3>
        <p>Yurt dışında eğitim almak veya çalışmak, yeni beceriler kazanmanıza, yeni insanlarla tanışmanıza, yeni deneyimler yaşamanıza ve yeni fikirler geliştirmenize olanak tanıyan, hayat değiştiren bir fırsattır.</p>
        
        <div className="coordinators-section">
            <h4>İlgili Personel ve Koordinatörler</h4>
            <div className="coordinators-grid">
                <div className="coordinator-card">
                    <h5>Erasmus Gelen Öğrenci Sorumlusu</h5>
                    <p>Tuba Yıldırım</p>
                    <span>tubayil@hacettepe.edu.tr</span>
                </div>
                <div className="coordinator-card">
                    <h5>Bölüm Koordinatörü</h5>
                    <p>Dr. Öğr. Üyesi Başak BULUT KARAGEYİK</p>
                    <span>basakbulut@hacettepe.edu.tr</span>
                </div>
                <div className="coordinator-card">
                    <h5>Erasmus Koordinatör Yardımcısı</h5>
                    <p>Arş. Gör. Özer Bakar</p>
                    <span>ozerbakar@hacettepe.edu.tr</span>
                </div>
            </div>
        </div>

        <h4>Başvuru Süreci</h4>
        <p>Öğrenciler kendi üniversiteleri tarafından aday gösterilmelidir. Aday gösterildikten sonra online başvuru yapmaya davet edileceklerdir. Tüm destekleyici belgeler elektronik olarak eklenebilir.</p>
        
        <h4>Dersler ve Dil Gereksinimleri</h4>
        <p>Dersler genellikle Türkçe verilmektedir, ancak aşağıda listelenen dersler İngilizce olarak sunulmaktadır. Ders kataloglarına ve detaylı bilgilere aşağıdaki linklerden ulaşabilirsiniz.</p>
        <h5>İngilizce Verilen Dersler:</h5>
        <ul>
            <li>AKT 401 ACTUARIAL APPLICATIONS</li>
            <li>AKT 413 FINANCIAL RISK MANAGEMENT</li>
            <li>AKT 206 FINANCIAL MATHEMATICS II</li>
        </ul>

        <h4>İlgili Bağlantılar</h4>
        <div className="program-links">
            <a href="#" target="_blank" rel="noopener noreferrer">Öğrenci Hareketliliği</a>
            <a href="#" target="_blank" rel="noopener noreferrer">Başvuru Formu (AP1.pdf)</a>
            <a href="#" target="_blank" rel="noopener noreferrer">Ders Kataloğu</a>
        </div>
    </div>
);

const MinorMajorSection = () => {
    const [expanded, setExpanded] = useState('yandal');

    const programs = {
        yandal: {
            title: 'Yan Dal Programı',
            icon: <FaBookReader />,
            content: (
                <>
                    <div className="mm-section">
                        <h4>Program Koordinatörleri</h4>
                        <div className="mm-coordinators-grid">
                            <div className="mm-coordinator-card">
                                <img src="https://aktuerya.hacettepe.edu.tr/pers/resimler/mby.jpg" alt="Murat Büyükyazıcı"/>
                                <h5>Dr. Öğr. Üyesi Murat Büyükyazıcı</h5>
                                <p>Koordinatör</p>
                                <span>muratby@hacettepe.edu.tr</span>
                            </div>
                             <div className="mm-coordinator-card">
                                <img src="https://avesis.hacettepe.edu.tr/user/image/7436" alt="Ezgi Nevruz"/>
                                <h5>Arş. Gör. Dr. Ezgi Nevruz</h5>
                                <p>Koordinatör Yardımcısı</p>
                                <span>ezginevruz@hacettepe.edu.tr</span>
                            </div>
                        </div>
                    </div>
                    <div className="mm-section">
                        <h4>Genel Bilgiler ve Başvuru</h4>
                        <p>Yandal Programı başvurusu yapacak öğrencilerimiz koşulları ve dikkat etmeleri gereken hususları, Hacettepe Üniversitesi Yandal Yönergesinden takip edebilirler...</p>
                    </div>
                     <div className="mm-section">
                        <h4>Karşılıklı Yandal Programımız Olan Bölümler</h4>
                        <div className="mm-directives">
                            <h5>2021-2022 Güz Öncesi:</h5>
                            <a href="#">Endüstri Mühendisliği</a> <a href="#">İstatistik</a> <a href="#">Matematik</a>
                            <h5>2021-2022 Güz Sonrası:</h5>
                             <a href="#">Endüstri Mühendisliği</a> <a href="#">İstatistik</a> <a href="#">Matematik</a>
                        </div>
                    </div>
                    <div className="mm-section">
                        <h4>Aktüerya Bilimleri Bölümünde Yandal Yapabilecek Diğer Bölümler</h4>
                        <p>İşletme ve İktisat Bölümü öğrencileri için Yandal Programları'na ilişkin yönergeler aşağıdadır.</p>
                        <div className="mm-directives">
                            <h5>2021-2022 Güz Döneminden Önce:</h5>
                            <a href="#">İşletme Bölümü ve İktisat Bölümü</a>
                            <h5>2021-2022 Güz Döneminden Sonra:</h5>
                            <a href="#">İşletme Bölümü ve İktisat Bölümü</a>
                        </div>
                    </div>
                     <div className="mm-section">
                        <h4>Aktüerya Öğrencileri İçin Yandal Fırsatları</h4>
                        <p>Bölümümüz öğrencileri yandal başvurusu yapabilecekleri bölümleri <a href="#">bu bağlantıdan</a> öğrenebilirler. Öğrencilerimizin gerekli bilgiler için ilgili bölümler ile iletişime geçmeleri gerekmektedir.</p>
                    </div>
                </>
            )
        },
        cap: {
            title: 'Çift Anadal Programı (ÇAP)',
            icon: <FaProjectDiagram />,
            content: (
                <>
                    <div className="mm-section">
                        <h4>Program Koordinatörleri</h4>
                        <div className="mm-coordinators-grid">
                             <div className="mm-coordinator-card">
                                <img src="https://aktuerya.hacettepe.edu.tr/pers/resimler/mby.jpg" alt="Murat Büyükyazıcı"/>
                                <h5>Dr. Ögr. Üyesi Murat Büyükyazıcı</h5>
                                <p>Koordinatör</p>
                                <span>muratby@hacetepe.edu.tr</span>
                            </div>
                            <div className="mm-coordinator-card">
                                <img src="https://aktuerya.hacettepe.edu.tr/pers/resimler/bzk.jpg" alt="Betül Zehra Karagül"/>
                                <h5>Arş. Gör. Betül Zehra Karagül</h5>
                                <p>Koordinatör Yardımcısı</p>
                                <span>betul.zehra@hacettepe.edu.tr</span>
                            </div>
                        </div>
                    </div>
                    <div className="mm-section">
                        <h4>Aktüerya Öğrencileri İçin Anlaşmalı Bölümler</h4>
                        <ul className="mm-list">
                            <li>Biyoloji</li>
                            <li>İstatistik</li>
                            <li>Matematik</li>
                        </ul>
                    </div>
                    <div className="mm-section">
                        <h4>Başvuru Bilgileri ve Süreç</h4>
                        <p>Çift Anadal Programı başvurusu yapacak öğrencilerimiz koşulları ve dikkat etmeleri gereken hususları, Hacettepe Üniversitesi Çift Anadal Yönergesinden takip edebilirler. Öğrencilerimiz ilgili bölümün Çift Anadal Lisans Programını, başvuru tarihlerini ve kontenjanlarını ilgili bölüm internet sayfasından ya da ilgili bölümün Çift Anadal Koordinatöründen öğrenebilirler.</p>
                        <p><strong>Aktüerya Bilimleri Bölümü'nde Çift Anadal (Diğer Bölüm Öğrencileri İçin):</strong> Öğrencinin akademik danışmanının onayını da içeren bir dilekçe ve transkripti ile birlikte başvuru tarihleri içinde Aktüerya Bilimleri Bölümü başkanlığına başvuru yapması gerekmektedir.</p>
                    </div>
                    <div className="mm-section">
                        <h4>Yönergeler ve Dilekçe</h4>
                        <div className="mm-directives">
                            <a href="#">Örnek Başvuru Dilekçesi</a>
                            <a href="#">İstatistik Bölümü İçin Yönerge</a>
                            <a href="#">Matematik Bölümü İçin Yönerge</a>
                            <a href="#">Biyoloji Bölümü İçin Yönerge</a>
                        </div>
                    </div>
                </>
            )
        }
    };

    return (
        <div className="actuarial-section">
             <div className="programs-container-accordion">
                {Object.keys(programs).map(key => {
                    const program = programs[key];
                    const isExpanded = expanded === key;
                    return (
                        <div className="program-accordion-item" key={key}>
                            <button className={`program-accordion-header ${isExpanded ? 'expanded' : ''}`} onClick={() => setExpanded(isExpanded ? null : key)}>
                                <div className="program-header-title">
                                    {program.icon}
                                    <h3>{program.title}</h3>
                                </div>
                                <motion.div animate={{ rotate: isExpanded ? 0 : -180 }}><FaChevronUp /></motion.div>
                            </button>
                            <AnimatePresence>
                                {isExpanded && (
                                    <motion.div
                                        initial="collapsed"
                                        animate="open"
                                        exit="collapsed"
                                        variants={{
                                            open: { opacity: 1, height: 'auto', marginTop: '1.5rem' },
                                            collapsed: { opacity: 0, height: 0, marginTop: 0 }
                                        }}
                                        transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
                                    >
                                        <div className="program-accordion-content">
                                            {program.content}
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ActuarialScience;


